import React from "react";
import useForm from "../services/UseForm";
import validate from '../validations/admin/loginValidate';
import ManeeCafeLogo from '../img/logo/ManeeCafeLogo.png';
import '../css/login.css';
import { API } from "../services/api";
import axios from "axios";

axios.defaults.baseURL = API;

export default function Login({setLogin, setUserID, setshowMainmenu, setLocationID, setTell, setAddress, setLocationName, setUserName, setRole}) {
  
  const handleInputChange = event => {
    const { name, value } = event.target;
    handleChange(name, value)
  };

  const handleLogin = () => {
    let data = { UserName: values.UserName, Password: values.Password };
    axios
      .post("/login-user", data).then((response) => {
        let userData = response?.data?.data;
        let token = response?.data?.token;
        let userDataString = JSON.stringify(userData);
        localStorage.setItem("data", userDataString);
        localStorage.setItem("token", token);
        setUserID(userData.EmployeeID);
        setLocationID(userData.LocationID);
        setLocationName(userData.LocationName);
        setAddress(userData.Address);
        setUserName(userData.Name);
        setTell(userData.Tell);
        setLogin(true);
        setRole(userData.Role);
        getAllPaymentType();
        getAllLocation();
        getAllStatus();
        getAllUser();
        getAllRole();
        setshowMainmenu(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  async function getAllPaymentType() {
    axios
      .get("/getAllPaymentType")
      .then((response) => {
        let Data = response?.data;
        let DataString = JSON.stringify(Data);
        localStorage.setItem("paymentTypeData", DataString);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllLocation() {
    axios
      .get("/getAllLocation")
      .then((response) => {
        let Data = response?.data;
        let DataString = JSON.stringify(Data);
        localStorage.setItem("locationData", DataString);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllStatus() {
    axios
      .get("/getAllStatus")
      .then((response) => {
        let Data = response?.data;
        let DataString = JSON.stringify(Data);
        localStorage.setItem("statusData", DataString);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllUser() {
    axios
      .get("/getUsers")
      .then((response) => {
        let Data = response?.data;
        let DataString = JSON.stringify(Data);
        localStorage.setItem("userData", DataString);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllRole() {
    axios
      .get("/getAllRole")
      .then((response) => {
        let Data = response?.data;
        let DataString = JSON.stringify(Data);
        localStorage.setItem("roleData", DataString);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
  } = useForm(handleLogin, validate);

  return (
    <div className="LoginContainer">
        <div className="loginleftcontainer">
            <form onSubmit={handleSubmit} noValidate>
                <h1>Sign in</h1>
                  <div className="inputtext1">
                      <input autoComplete="off" placeholder="User Name" className={`input form-control ${errors.UserName && 'is-invalid'}`} name="UserName" onChange={(e) => handleInputChange(e)} value={values.UserName || ''} required />
                      {errors.UserName && (<p className="invalid-feedback" >{errors.UserName}</p>)}
                  </div>
                  <div className="inputtext2">
                      <input className={`input form-control ${errors.Password && 'is-invalid'}`} placeholder="Password" type="Password" name="Password" onChange={(e) => handleInputChange(e)} value={values.Password || ''} required />
                      {errors.Password && (
                          <p className="invalid-feedback">{errors.Password}</p>
                      )}
                  </div>
                  
                <button className="btnLogin" type="submit" value="Login">Sign In</button>
            </form>
        </div>
        <div className="loginRightcontainer">
            <div className="">
                    <img src={ManeeCafeLogo} className="logo"/>
            </div>
        </div>
    </div>
  );
}

